import DADOS_SIMULADOS from './dados-simulados.json';
import type { LinhaRelatorioSme } from './tipos';

/**
 * A porta única de dados do Relatórios SME. Nenhum componente desta tela lê o
 * JSON: quando o endpoint existir, só este arquivo muda.
 *
 * TEMPORÁRIO — mock local, remover no desenvolvimento do backend. Não existe
 * módulo que agregue este recorte em `apps/api/src/modulos/`, e sem dado não há
 * como validar a interface com a SMT/DTP. Mesmas três condições de sempre: só
 * leitura, dado claramente fictício, removido antes de `develop` → `hml`
 * (`git grep -n "TEMPORÁRIO" apps/web/src`, checklist em `docs/ALVOS.md`).
 *
 * NENHUMA DATA LITERAL. O arquivo guarda a distância em meses até o mês
 * anterior ao de quem executa (`mesesAtras`), nunca "2026-03": data fixa
 * envelhece sozinha e um dia mostra à SMT um relatório de meses que já
 * passaram — ou esvazia a tela e derruba teste em PR sem relação.
 */

interface LinhaCrua extends Omit<LinhaRelatorioSme, 'competencia'> {
  mesesAtras: number;
}

/** "Há n meses" a partir do mês corrente, no formato "AAAA-MM". */
export function competenciaDeMesesAtras(mesesAtras: number, hoje = new Date()): string {
  const mes = new Date(hoje.getFullYear(), hoje.getMonth() - mesesAtras, 1);
  return `${mes.getFullYear()}-${String(mes.getMonth() + 1).padStart(2, '0')}`;
}

/** O recorte inteiro, com a competência de cada linha resolvida contra o relógio. */
export function carregarRelatorioSme(hoje = new Date()): LinhaRelatorioSme[] {
  return (DADOS_SIMULADOS as LinhaCrua[]).map(({ mesesAtras, ...linha }) => ({
    ...linha,
    competencia: competenciaDeMesesAtras(mesesAtras, hoje),
  }));
}
